module.exports = __webpack_public_path__ + "static/zui16_img/erwei-code.a1481112.png";